module.exports = __webpack_public_path__ + "static/media/android.4db87232.jpg";